import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core'
import * as GaugeChart from 'gauge-chart'

export interface GaugeChartOptions {
  hasNeedle?: boolean
  needleColor?: string
  needleUpdateSpeed?: number
  arcColors?: string[]
  arcDelimiters?: number[]
  arcOverEffect?: boolean
  arcLabels?: string[]
  arcPadding?: number
  arcPaddingColor?: string
  rangeLabel?: string[]
  centralLabel?: string
  needleStartValue?: number,
  rangeLabelFont?: string
  rangeLabelFontSize?: number
}

@Component({
  selector: 'app-gauge-chart',
  imports: [],
  templateUrl: './gauge-chart.component.html',
  styleUrl: './gauge-chart.component.css'
})
export class GaugeChartComponent implements OnInit, OnChanges {
  @ViewChild('gaugeArea', { static: true }) gaugeArea!: { nativeElement: Element };

  @Input() canvasWidth = 0
  @Input() needleValue = 0
  @Input() centralLabel = ''
  @Input() options: GaugeChartOptions = {}
  @Input() name = ''
  @Input() nameFont = ''
  @Input() bottomLabel = ''
  @Input() bottomLabelFont = ''

  public nameMargin = ''
  public bottomLabelMargin = ''

  private element!: Element
  private gaugeChart!: ReturnType<typeof GaugeChart['gaugeChart']>;

  ngOnInit() {
    // calculate styles for name and bottomLabel
    if (this.name) {
      if (!this.nameFont) {
        this.nameFont = '' + Math.round(this.canvasWidth / 15)
      }
      this.nameMargin = '' + Math.round(+this.nameFont / 4)
    }

    if (this.bottomLabel) {
      if (!this.bottomLabelFont) {
        this.bottomLabelFont = '' + Math.round(this.canvasWidth / 10)
      }
      this.bottomLabelMargin = '-' + this.bottomLabelFont
    }

    if (this.optionsCheck()) {
      this.element = this.gaugeArea.nativeElement
      this.options.centralLabel = this.centralLabel
      // Drawing and updating the chart
      this.gaugeChart = GaugeChart.gaugeChart(
        this.element,
        this.canvasWidth,
        this.options,
      )
      this.gaugeChart.updateNeedle(this.needleValue)
    }
  }

  optionsCheck() {
    if (this.canvasWidth == null) {
      console.warn('gauge-chart warning: canvasWidth is not specified!')
      return false
    } else if (this.needleValue == null) {
      console.warn('gauge-chart warning: needleValue is not specified!')
      return false
    }
    if (this.centralLabel == null) {
      this.centralLabel = ''
    }
    return true
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.needleValue && !changes.needleValue.firstChange) {
      if (
        changes.needleValue.currentValue !== changes.needleValue.previousValue
      ) {
        this.needleValue = changes.needleValue.currentValue
        this.gaugeChart.updateNeedle(this.needleValue)
      }
    }
    if (changes.centralLabel && !changes.centralLabel.firstChange) {
      if (
        changes.centralLabel.currentValue !== changes.centralLabel.previousValue
      ) {
        this.gaugeChart.removeGauge()
        this.centralLabel = changes.centralLabel.currentValue
        this.options.centralLabel = this.centralLabel
        this.gaugeChart = GaugeChart.gaugeChart(
          this.element,
          this.canvasWidth,
          this.options,
        )
        this.gaugeChart.updateNeedle(this.needleValue)
      }
    }
    if (changes.centralLabel && !changes.centralLabel.firstChange) {
      if (
        changes.bottomLabel.currentValue !== changes.bottomLabel.previousValue
      ) {
        console.log(changes.bottomLabel.currentValue)
      }
    }
  }
}
